import {Component, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {GlobalState} from "@store/state/global.state";
import {AppState} from "@store/state/app.state";
import {Store} from "@ngrx/store";
import {NavigationExtras, Router} from "@angular/router";
import {ApiArticlesGetAllowedValues} from "@api/articles";
import {UrlParameter} from "@iw-shop/article/model/articles-list-handler";
import {ConfigService} from "@iw-shop/config/service/config.service";
import {ApiFilter, ApiFilterDeprecated} from "@api/filter";

@Component({
    selector: 'iw-shop-article-menu-groups',
    standalone: false,
    templateUrl: './article-menu-groups.component.html',
    styleUrls: ['./article-menu-groups.component.scss']
})
export class ArticleMenuGroupsComponent implements OnInit {


    global$: Observable<GlobalState | undefined>;

    selectedGroup?: string;
    selectedGroup1?: string;

    constructor(private store: Store<AppState>,
                private router: Router,
                private configService: ConfigService) {
        this.global$ = this.store.select(state => state.global);
    }

    ngOnInit(): void {
    }


    protected readonly encodeURIComponent = encodeURIComponent;

    setSelectedGroup(group: string) {
        this.selectedGroup = group;
    }
    setSelectedGroup1(group: string) {
        this.selectedGroup1 = group;
    }

    navigateToGroup1(group: string, group1: string) {
        let extras: NavigationExtras = {};

        const filterGroup1: ApiFilter<ApiArticlesGetAllowedValues['filterFields']> = {field: 'groups.group1Name', value: group1};

        const urlParameter: UrlParameter = this.configService.getDefaultArticleListRequestParams();
        if (urlParameter.filters &&
            urlParameter.filters.length > 0) {
            urlParameter.filters.push(filterGroup1)
        } else {
            urlParameter.filters = [filterGroup1];
        }


        extras.queryParams = {
            p: btoa(JSON.stringify(urlParameter))
        };
        this.router.navigate(['/sortiment/', group], extras).then();
    }
}
